/**
 * These scripts are deferred to load after domcontent loaded anyway, so no trigger.
 * */
const { default: getHighchartsBundle } = require("../lazy-bundles/load-highcharts-bundle");

window.initCalenderReturnsChart = async function () {
    await getHighchartsBundle();
    $(".charttablenav").each(function (i, val) {
        //if the config is not there there is nothing to render
        if(typeof CalanderYearReturnChartConfig === "undefined") return console.error("Couldn't find chart data object");


        var html = val.ownerDocument.all;
        var descriptionData = "";
        if ($("calenderChart-title").length) {
            var titleName = $("calenderChart-title").text();
            var tickerName = $("calenderChart-ticker").text();
            //var titleName = titleElement.innerText;
            descriptionData = "Bar Chart illustrating past performance by " + titleName +". The x - axis represents time and the y - axis represents percent return.";
            if (tickerName!=null) {
                //var tickerName = tickerElement.innerText;
                if (tickerName.trim() !== "" && tickerName !== undefined) {
                    descriptionData = "Bar Chart illustrating past performance of " + tickerName + " ETF by Calendar year. The x - axis represents time and the y - axis represents percent return.";
                }
            }
        }

        var uniqueName = "chart" + i;
        $(val).attr("id", uniqueName);

        var sCategories = parseJSONHTML(CalanderYearReturnChartConfig.categories);
        var masData = parseJSONHTML(CalanderYearReturnChartConfig.seriesData);
        var nodata = CalanderYearReturnChartConfig.noDataText ?? "";

        var colours = ["#17468f", "#0ab2bf", "#108A12", ...feutils.veColors]

        //override colors with our list of colors
        masData.forEach((e, i) => masData[i].color = colours[i])

        if (nodata !== '') return $('#' + uniqueName).html(nodata);

            var chart = new Highcharts.Chart({
                chart: {
                    renderTo: uniqueName,
                    type: 'column',
                    height: 400
                },
                title: {
                    text: ''
                },
                xAxis: {
                    categories: sCategories,
                    lineColor: '#000000',
                    lineWidth: 1
                },
                yAxis: {
                    title: {
                        text: ''
                    },
                    lineColor: '#000000',
                    lineWidth: 1,
                    maxPadding: 0.1
                },
                legend: {
                    useHTML: true,
                    layout: 'vertical',
                    align: 'right',
                    verticalAlign: 'top',
                    borderWidth: 0,
                    floating: true
                },
                tooltip: {
                    formatter: function () {
                        return '' +
                            this.series.name + ': ' + this.y + '';
                    }
                },
                credits: {
                    enabled: false
                },
                accessibility: {
                    description: descriptionData
                },
                series: masData
            });
            chart.legend.group.div.setAttribute('data-ve-gtm', 'chart-legend');
    });
}

function parseJSONHTML(val) {
    try {
        return $.parseJSON($.parseHTML(val)[0].data)
    }
    catch (err) {
        console.error(err);
        return [];
    }
}